export const PG_FEATURESERV = import.meta.env.VITE_PG_FEATURESERV_URL || `${import.meta.env.VITE_API_ORIGIN}/features`;
